import { atom } from 'jotai'

import { type DraggingMultipleShipmentOrders } from '../../-models'

/**
 * ドラッグ中の配送依頼（新規に配車するパターン）
 */
export const draggingMultipleShipmentOrdersAtom =
  atom<DraggingMultipleShipmentOrders | null>(null)

draggingMultipleShipmentOrdersAtom.debugLabel = 'draggingShipmentOrderAtom'
